import PropTypes from 'prop-types'

import { NotyRendererUI } from './NotyRenderer.css'

import { ItemShape } from '../../Noty.constants'
import NotyElement from '../NotyElement'

/**
 * @typedef {import('../../Noty.constants').TNotyItem} TNotyItem
 * @param {{notys: Array.<TNotyItem>}}
 */
function NotyRenderer({ notys }) {
  return (
    <NotyRendererUI data-testid="NotyRenderer">
      {notys.map(item => (
        <NotyElement key={item.id} {...item} />
      ))}
    </NotyRendererUI>
  )
}

NotyRenderer.propTypes = {
  notys: PropTypes.arrayOf(PropTypes.shape(ItemShape)),
}

export default NotyRenderer
